module.exports = __webpack_public_path__ + "img/ps-44.9c2cd650.jpg";